import React from 'react';
import { ProgressBar } from '@progress/kendo-react-progressbars';
import { downloadFileFromBlobByAxios } from 'utils/FpFileDownload/file-download-service';
import { useNotificationFasade } from 'redux/notification/notification.facade';
import { useIntl } from 'hooks/intl';

export interface FpFileDownloadProgressBarProps {
  downloadUrl: string,
  fileName: string,
  value: string,
  downloadFinished: () => void,
}

export function FpFileDownloadProgressBar(props: FpFileDownloadProgressBarProps) {
  const intl = useIntl();
  const [progress, setProgress] = React.useState(0);
  const { addErrorNotification } = useNotificationFasade();
  const onProgress = (event: any) => {
    setProgress(Math.floor(event.loadedBytes / event.total * 100));
  };

  React.useEffect(() => {
    (() => {
      downloadFileFromBlobByAxios(props.downloadUrl, props.fileName, onProgress)
        .then(() => props.downloadFinished())
        .catch(() => {
          addErrorNotification('FpPortal.DownloadError', [props.value]);
        });
    })();
  // eslint-disable-next-line
  }, [props.downloadUrl]);

  return (
    <ProgressBar
      style={{ width: '100%', minWidth: '120px' }}
      value={progress}
      label={() => (
        <strong style={{ color: '#FFFFFF' }}>
          {progress === 0 ? intl.formatMessage('notification.download.waiting') : `${progress}%`}
        </strong>
      )}
    />
  );
}
